import React from "react";
import PropTypes from "prop-types";
import DataTable from "@client.components/DataTable";
import { getTimeConsumingMeetingColumns } from "../consts";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeProfile } from "@client.pages/Login/reducer";

const MeetingDetailsContent = ({ details, meetings, timeFrame, isLoading }) => {
  const { t } = useTranslation();
  const profile = useSelector(makeProfile);
  return (
    <div className="meeting-tooltip-details">
      {details &&<div className="details">{details}</div>}
      <DataTable
        columns={getTimeConsumingMeetingColumns(
          t,
          profile.isCostIndexPresentation,
          meetings.some((m) => m.name),
          meetings.some((m) => m.meetingType),
          timeFrame && timeFrame !== "day"
        )}
        data={meetings}
        isLoading={isLoading}
      />
    </div>
  );
};

MeetingDetailsContent.propTypes = {
  meetings: PropTypes.array,
  details: PropTypes.string,
  timeFrame: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default MeetingDetailsContent;
